import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import { NAV_LINKS, useNavLinks } from "../header/useNavLinks";
const Footer = () => {
  const goToLink = useNavLinks();
  return (
    <>
      <section className="mainfooter" id="contact">
        <div className="custom-container">
          <div className="mainparent">
            <div className="left">
              <div className="mainlogo">
                <img
                  src="\logo.svg"
                  alt="img"
                  className="img-fluid logofooter"
                />
              </div>
              <p className="para">
                TraqStock is a market transparency platform providing verified
                company data, trading activity insights, and identity-verified
                investor discussions.
              </p>
              <div className="social">
                <a href="https://x.com/traqstock" target="_blank">
          
                  <img src="\assets\twitter.svg" alt="img" className="img-fluid"/>
                </a>
              </div>
            </div>
            <div className="right">
              <div className="parenttext">
                <div className="left">
                  <h2>Platform</h2>
                  {NAV_LINKS.map((link) => (
                    <a
                      key={link.label}
                      onClick={() => goToLink(link)}
                      style={{ cursor: "pointer" }}
                    >
                      {link.label}
                    </a>
                  ))}
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <div className="left">
                  <h2>Newsletter</h2>
                  <div className="leftparentmain">
                    <input type="text" placeholder="Enter Your Email" />
                    <img
                      src="\assets\arrowright.svg"
                      alt="img"
                      className="img-fluid arrow"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="brdr"></div>
            <p>© 2026 TRAQSTOCK. All rights reserved.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
